// Shared layout + type tokens for the "How AI Voice Typing Actually Works"
// article. They mirror the tokens used by the Google Docs article so both
// pages render headings, body copy and cards with identical styling.

// Offset so a smooth-scrolled section never lands under the fixed navbar.
export const SCROLL_OFFSET = 120;

// Section heading — same scale/tracking as the Google Docs article's h2.
export const H2 =
  "font-jakarta font-bold text-[#0A0D16] text-[28px] sm:text-[36px] md:text-[44px] lg:text-[50px] leading-[1.28] lg:leading-[64px] tracking-[-0.8px]";

// Standard body paragraph.
export const BODY =
  "font-inter text-[16px] font-normal leading-[29.6px] tracking-[0px] text-[#0A0D16B2]";

// Smaller body copy used inside cards and the numbered timeline.
export const BODY_SM =
  "font-inter text-[14px] font-normal leading-[26px] tracking-[0px] text-[#0A0D16B2]";

// Card / sub-card title.
export const CARD_TITLE =
  "font-jakarta text-[16.1px] font-bold leading-[26.16px] tracking-[0px] text-[#0A0D16]";

// Uppercase micro-label (table headers, card eyebrows).
export const LABEL =
  "font-inter text-[12.88px] font-bold uppercase leading-[19.32px] tracking-[0.32px]";

// Small sentence-case eyebrow used inside the workflow cards.
export const EYEBROW =
  "font-jakarta text-[12px] font-semibold leading-[18px] tracking-[0.02em]";

export const GRADIENT_TEXT =
  "inline-block bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] bg-clip-text text-transparent";

// Step-chip surface, shared by the pipeline chips in every section so a
// "Speak → Transcribe → …" box reads the same wherever it appears.
export const STEP_BACKGROUND =
  "linear-gradient(0deg, #FAF9F6, #FAF9F6), linear-gradient(0deg, #C9E9FC, #C9E9FC)";

export const CARD_SHADOW =
  "0px 10.73px 32.19px -12.88px #173A8C24, 0px 1.07px 2.15px 0px #0A0E190A";

// Page gutter — identical to the Google Docs article container.
export const CONTAINER = "max-w-[1440px] mx-auto px-6 md:px-12 lg:px-[101px]";

// Two-column split used by the timeline and workflow sections.
export const COL_LEFT = "w-full lg:w-[442px] shrink-0";
export const COL_RIGHT = "w-full flex-1 min-w-0";
